import i18next from 'i18next';

import { normalizeKeys } from '@commons/Excels/utils';
import normalizeStringValue from '@commons/utils/normalizeStringValue';

const getBufferStockSheetConfig = () => {
  const columns = {
    NAME: i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.INGREDIENT_NAME_COLUMN'),
    INGREDIENT_ID: 'ingredientId',
  };

  const normalizedColumns = normalizeKeys(columns);

  return {
    SHEET: {
      id: 'bufferStocks',
      name: i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.BUFFER_STOCK_SHEET_NAME'),
    },
    COLUMN_IDS: {
      NAME: 'name',
      INGREDIENT_ID: 'ingredientId',
    },
    COLUMNS_CONFIG: normalizedColumns,
  };
};

const getNormalizedColumnIds = () => ({
  NAME: {
    key: 'name',
    normalizedKey: normalizeStringValue(
      i18next.t('_BACKEND_TRANSLATIONS.ENTITIES.INGREDIENTS_IMPORTS.INGREDIENT_NAME_COLUMN'),
    ),
  },
  INGREDIENT_ID: {
    key: 'ingredientId',
    normalizedKey: 'ingredientid',
  },
});

export default {
  getBufferStockSheetConfig,
  getNormalizedColumnIds,
};
